import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import React from 'react';
import SimpleImageLoader from '../../../Atoms/SimpleImageLoader';
import Typography from '@material-ui/core/Typography';

import { FormControlLabel, Switch } from '@material-ui/core';
import ImageSelectionAndCropper from "../../../Organisms/ImageSelectionAndCropper";
export interface IChannelsFormDetailsProps {
    nameField: string;
    isNameHidden: boolean;
    imageURL: string;
    handleNameChange: any;
    handleIsNameHiddenChange: any;
    handleFileChange: any;
    nameEmpty: boolean;
}

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
    },
    input: {
        display: 'none',
    },
}));

const ChannelsFormDetails = ({
    handleFileChange,
    handleNameChange,
    imageURL,
    nameEmpty,
    nameField,
    isNameHidden,
    handleIsNameHiddenChange
}: IChannelsFormDetailsProps) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Typography gutterBottom variant="h6">
                New Channel Details
            </Typography>
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <FormControl className={classes.formControl} error={nameEmpty}>
                        <InputLabel htmlFor="channel-name">Name</InputLabel>
                        <Input
                            aria-describedby="channel-name-field-error-text"
                            autoFocus
                            id="channel-name"
                            onChange={handleNameChange}
                            placeholder="Channel name"
                            value={nameField}
                        />
                        <FormHelperText id="channel-name-field-error-text">
                            Please enter a name for your channel
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <FormControlLabel
                        control={
                            <Switch
                                inputProps={{ 'aria-label': 'Hide name?' }}
                                onChange={handleIsNameHiddenChange}
                                name={'isNameHidden'}
                                checked={isNameHidden}
                                value={isNameHidden}
                            />
                        }
                        label={'Hide name?'}
                        labelPlacement="top"
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <ImageSelectionAndCropper
                        postSelectionButtonText={'Use Photo'}
                        aspectRatio={1024/284}
                        handleFileSelection={handleFileChange}
                        recommended={{width:1024, height:284}}/>
                </Grid>
                <Grid item xs={12}>
                    {imageURL && <SimpleImageLoader alt="Channel background" src={imageURL} width={300} />}
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default ChannelsFormDetails;
